import { render, staticRenderFns } from "./userVirtualTheme.vue?vue&type=template&id=53215237&"
import script from "./userVirtualTheme.vue?vue&type=script&lang=js&"
export * from "./userVirtualTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports